module.exports = __webpack_public_path__ + "static/media/21ECLAC38.0ef64f52.jpg";